import React from "react";

export default function ProfileError() {
  return (
    <div>You are not logged in. Please log in first to access this page.</div>
  );
}
